import { EXTERNAL_ID } from 'consts';
import { IUserAttribute, IUserAttributeMapping } from 'types/api';

export const getMissingMandatoryMappings = (
	userAttributes: IUserAttribute[],
	existingMappings: IUserAttributeMapping[]
): IUserAttributeMapping[] => {
	const requiredAttrs = userAttributes.filter((a) => a.required);
	const missing: IUserAttributeMapping[] = [];
	for (const attr of requiredAttrs) {
		if (!existingMappings.some((m) => m.spAttr === attr.value)) {
			missing.push({
				idpAttr: null,
				spAttr: attr.value
			});
		}
	}
	return missing;
};

export const sortMappings = (
	mappings: IUserAttributeMapping[],
	userAttributes: IUserAttribute[]
): IUserAttributeMapping[] =>
	[...mappings].sort((a, b) => {
		const aIsExternalId = a.spAttr === EXTERNAL_ID;
		const bIsExternalId = b.spAttr === EXTERNAL_ID;
		if (aIsExternalId !== bIsExternalId) {
			return Number(bIsExternalId) - Number(aIsExternalId);
		}
		const aRequired = !!userAttributes.find((ua) => ua.value === a.spAttr)
			?.required;
		const bRequired = !!userAttributes.find((ua) => ua.value === b.spAttr)
			?.required;
		if (aRequired !== bRequired) {
			return aRequired ? -1 : 1;
		}
		return 0;
	});

export const getInitialSortedMappings = (
	userAttributes: IUserAttribute[],
	existingMappings: IUserAttributeMapping[]
): IUserAttributeMapping[] => {
	const missingMandatory = getMissingMandatoryMappings(
		userAttributes,
		existingMappings
	);
	const combined = [...existingMappings, ...missingMandatory];
	return sortMappings(combined, userAttributes);
};
